﻿'use strict';

/**
* Factory for interacting with the Restangular and Setting connections to outside services up
* @memberOf components.connectionsModule
* @namespace connectionsFactory
*/

connectionsFactory.$inject = ['$http', '$cookies', 'Restangular', 'authenticationFactory', 'envService', 'data_project_constants'];

function connectionsFactory($http, $cookies, Restangular, authenticationFactory, envService, data_project_constants) {
    var service = {};

    /**
    * Gets a connection for the values end point
    * @method getApplicationAPIConnection
    * @returns {Object:Restangular} end point for API values
    * @memberOf components.connectionsModule.connectionsFactory
    */
    service.getApplicationAPIConnection = function (applicationEndpoint) {
        return Restangular.withConfig(function (config) {
            config.setDefaultHttpFields({
                withCredentials: true
            });

            config.setBaseUrl(envService.read(applicationEndpoint));

            // Set up request handler here to pass on the api auth token
            config.addFullRequestInterceptor(function (element, operation, route, url, headers, params, httpConfig) {
                return {
                    headers: {
                        'Authorization': 'Bearer ' + authenticationFactory.getOktaAuthenticationObject().accessToken.value,
                        'HEADER-CSRF-TOKEN': $cookies.get(data_project_constants.cookies.csrf_name)
                    }
                };
            });
        });
    }

    return service;
}

module.exports = connectionsFactory;



//////////////////
// WEBPACK FOOTER
// ./source/angular/components/connections/connectionsFactory.js
// module id = 25
// module chunks = 0